import { generatePath, useLocation } from "react-router-dom";
import routing from "routing";

export default function useSearchParams() {
	const { pathname } = useLocation();

	return generatePath(
		Object.entries(routing.menuSection).find(([key]) => {
			return pathname.startsWith(key);
		})[1],
	);
}
